var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"left"},[_c('a',{attrs:{"href":"/terms"}},[_vm._v("Terms of Service")]),_c('a',{attrs:{"href":"/privacypolicy"}},[_vm._v("Privacy policy")])]),_c('div',{staticClass:"right"},[_vm._v("©MiniGame Lab. All Rights Reserved.")])])])
}]

export { render, staticRenderFns }